import { render, staticRenderFns } from "./ColorThemePicker.vue?vue&type=template&id=64b0c3a3&lang=pug&"
import script from "./ColorThemePicker.vue?vue&type=script&lang=ts&"
export * from "./ColorThemePicker.vue?vue&type=script&lang=ts&"
import style0 from "./ColorThemePicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b0c3a3')) {
      api.createRecord('64b0c3a3', component.options)
    } else {
      api.reload('64b0c3a3', component.options)
    }
    module.hot.accept("./ColorThemePicker.vue?vue&type=template&id=64b0c3a3&lang=pug&", function () {
      api.rerender('64b0c3a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/ColorThemePicker.vue"
export default component.exports